import { ITriggerWhenActivityInData } from "./ITriggerWhenActivityIn"
import { useTranslation, useProxyWatch } from "@fanfanlo";
import { Box, Grid2, Stack, Button } from "@mui/material";
import { useRouter } from "next/router";
import { childToProjectDataUtils, IChildToProjectData } from "../../../utils";
import { IActionOrTriggerListPageParams, ActionOrTriggerListTypeEnum } from "@app/static";
import { triggerWhenActivityInUtils } from "./ITriggerWhenActivityIn";
export function UI(data: ITriggerWhenActivityInData){
    const { t } = useTranslation('droid-project-interface/triggers/app/when-activity-in/content')
    const router = useRouter()
    const backPath = router.pathname;
    const [pn] = useProxyWatch(data, "javaData.pn", data.javaData.pn)
    const [an] = useProxyWatch(data, "javaData.an", data.javaData.an)
    const [cn] = useProxyWatch(data, "javaData.cn", data.javaData.cn)
    function onChangeClick() {
        const projectInfo: IChildToProjectData = {}
        childToProjectDataUtils.triggerList.getTriggerListByProp(data, projectInfo)
        if (!projectInfo.project?.id || !projectInfo.triggerActionGroup?.id || !projectInfo.triggerAction?.id || !projectInfo.triggerGroup?.id) {
            console.error('UpdateAppLink projectInfo is undefined', projectInfo)
            return
        }

        const query: IActionOrTriggerListPageParams = {
            backPath,
            projectId: projectInfo.project?.id,
            triggerActionGroupId: projectInfo.triggerActionGroup?.id,
            triggerActionId: projectInfo.triggerAction?.id,
            triggerGroupId: projectInfo.triggerGroup?.id,
            type: ActionOrTriggerListTypeEnum.updateAction,
            triggerId: data.id,
            triggerType: triggerWhenActivityInUtils.type,
        }
        triggerWhenActivityInUtils.onClickChange?.({query})
    }
    return(
        <>
            <Box sx={{ width: '100%' }}>
                <Box>
                    <b>{t('content.title')}</b>
                </Box>
                <Grid2 container sx={{ width: '100%' }}>
                    <Grid2 size="grow" container>
                        <Stack direction="column" spacing={2}>
                            <Box>
                                <span>
                                    {t('content.pnLabel')}
                                </span>
                                <span>
                                    {pn}
                                </span>
                            </Box>
                            <Box>
                                <span>
                                    {t('content.anLabel')}
                                </span>
                                <span>
                                    {an}
                                </span>
                            </Box>
                            <Box>
                                <span>
                                    {t('content.cnLabel')}
                                </span>
                                <span>
                                    {cn}
                                </span>
                            </Box>
                        </Stack>
                    </Grid2>
                    <Grid2 size={"auto"}>
                        <Button onClick={onChangeClick}>
                            <span>{t('content.changeBtnLabel')}</span>
                        </Button>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    )
}